import { useSearchParams } from 'react-router-dom';

const EmbeddedAccountsTestPage = () => {
  const [searchParams] = useSearchParams();
  const contactId = searchParams.get("cu"); // customerCOntactId

  const url = `${window.location.origin}/embeddedaccountpayment?cu=${contactId}`;

  // todo, 
  return (<div className="w-full py-32 flex items-center justify-center bg-blue-200">
    <iframe className="w-[800px] h-[800px]" src={url} />
  </div>);
}

export default EmbeddedAccountsTestPage;